<template>
  <div class="widget white_box">
    <div class="widget_header">
      <div class="location_tag">
        <h3 class="tw-text-neutral-900 tw-text-2xl">
          Phone Calls - Google Business Profile
        </h3>
        <div class="sub_heading">
          Location: {{ selectedLocation }}
        </div>
      </div>
      <DefaultButton
        v-if="!editing && !preview"
        size="small"
        as="a"
        href="/local/business-profile/performance"
      >
        See more
      </DefaultButton>
      <div
        v-if="editing && !preview"
        class="edit_buttons tw-flex tw-gap-2"
      >
        <DefaultButton
          size="small"
          variant="primary-inverted"
          @click="$parent.edit(widget)"
        >
          Options
        </DefaultButton>

        <DefaultButton
          size="small"
          variant="danger"
          @click="$parent.remove(widget)"
        >
          Delete
        </DefaultButton>
      </div>
    </div>
    <apexchart
      v-if="!loading && !error"
      :options="chartOptions"
      :series="series"
      height="300"
      type="area"
    />

    <div
      v-if="loading && !error"
      class="loading_widget_data"
    >
      <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
    </div>

    <div
      v-if="error"
      class="widget_error"
      v-html="error"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import axios from 'axios';
import _ from 'lodash';
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

export default {
  components: {
    DefaultButton,
  },
  props: {
    widget: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: true,
      error: '',
      series: [{
        name: "Phone Calls",
        data: []
      }],
      options: {
        colors: ['#efa75b'],
        xaxis: {
          categories: [],
          type: 'datetime',
        },
        tooltip: {
          x: {
            format: 'd MMM yyyy',
          }
        }
      }
    }
  },
  computed: {
    ...mapState('dashboard', ['chartBaseOptions', 'uuid', 'preview', 'gmbLocations']),
    chartOptions() {
      return {
        ...this.chartBaseOptions,
        ...this.options
      };
    },
    selectedLocation() {
      return this.gmbLocations[this.widget.location_id];
    }
  },
  watch: {
    'widget.location_id': {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.fetchData();
      },
      deep: true
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      axios.post('/ajax/dashboard/get-widget-data', {
        type: 'phoneCalls',
        location_id: this.widget.location_id,
        uuid: this.uuid
      }).then(response => {
        this.series[0].data = response.data.data;
        this.options.xaxis.categories = response.data.labels;
        this.loading = false;
      }).catch(error => {
        this.error = error.response.data;
        this.loading = false;
      });
    }
  },
}
</script>
